import type { JobRun } from '../api'

export const JOB_STATUS: Record<JobRun['status'], string> = {
  queued: 'Waiting',
  running: 'Running',
  succeeded: 'Done',
  failed: 'Failed',
}

/** A job's state, when, and what it came to or why it failed. */
export function JobLine({ run }: { run: JobRun }) {
  const when = run.finished_at ?? run.started_at ?? run.enqueued_at
  return (
    <>
      <span className={`job-status ${run.status}`}>{JOB_STATUS[run.status]}</span>{' '}
      {new Date(when).toLocaleString()}
      {run.summary && <span className="clause">{run.summary}</span>}
      {run.error && <span className="clause error">{run.error}</span>}
    </>
  )
}
